export function getDateDiff(ms) {
    const time = (new Date().getTime() - parseFloat(ms)) / 1000;
    let result = '';
    if (time) {
        if (time < 60) {
            result = '刚刚';
        } else if (time >= 60 && time < 3600) {
            result = `${parseInt(time / 60.0, 10)}分钟前`;
        } else if (time >= 3600 && time < 24 * 3600) {
            result = `${parseInt(time / 3600.0, 10)}小时前`;
        } else if (time >= 24 * 3600 && time < 30 * 24 * 3600) {
            result = `${parseInt(time / 3600.0 / 24.0, 10)}天前`;
        } else if (time >= 30 * 24 * 3600 && time < 12 * 30 * 24 * 3600) {
            result = `${parseInt(time / 3600.0 / 24.0 / 30, 10)}月前`;
        } else if (time >= 12 * 30 * 24 * 3600) {
            result = `${parseInt(time / 3600.0 / 24.0 / 30.0 / 12.0, 10)}年前`;
        } else {
            result = '';
        }
    }
    return result;
}
